import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useBlocker } from 'react-router-dom';
import { IconTipping } from '../components/Common/Icon';

interface ContentProps {
  title: string;
  description: string;
}

const usePreventNavigation = (when: boolean, content: ContentProps) => {
  const blocker = useBlocker(when);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setModalVisible(true);
    }
  }, [blocker.state]);

  const handleClose = () => {
    setModalVisible(false);

    // safely call reset() if available
    if (blocker && typeof blocker.reset === 'function') {
      blocker.reset();
    }
  };

  const modal = (
    <Modal
      open={modalVisible}
      // footer={null}
      footer={[
        <Button key="ok" type="primary" onClick={handleClose}>
          OK
        </Button>,
      ]}
      onOk={handleClose}
      closeIcon
      maskClosable
      closable={false}
      centered
      onCancel={handleClose}
    >
      <IconTipping />
      <h3 className="text-lg font-medium mb-2">{content.title}</h3>
      <p className="text-gray-500" style={{ fontWeight: 'bold' }}>
        {content.description}
      </p>
    </Modal>
  );

  return { modal };
};

export default usePreventNavigation;
